import { createClimateModule } from './createClimateModule';

export function buildClimateModule(appDeps) {
  const {
    useState,
    useEffect,
    useMemo,
    useCallback,
    useFarm,
    useFarmCollection,
    useGlobalCollection,
    useToast,
    ModuleHeaderMenu,
    Btn,
    Badge,
    Toast,
    T,
    fmtDate,
  } = appDeps;

  return createClimateModule({
    useState,
    useEffect,
    useMemo,
    useCallback,
    useFarm,
    useFarmCollection,
    useGlobalCollection,
    useToast,
    ModuleHeaderMenu,
    Btn,
    Badge,
    Toast,
    T,
    fmtDate,
  });
}

export default buildClimateModule;
